module.exports = __webpack_public_path__ + "img/2415661-92-4.5570dc81.png";